import { ChangeDetectionStrategy, Component, input, InputSignal, output, OutputEmitterRef } from '@angular/core';
import { SecondaryNavTab } from './secondary-nav-tab.interface';
import { CommonModule, NgClass } from '@angular/common';
import { IconSvgComponent } from '../icon/icon.component';

@Component({
  standalone: true,
  selector: 'rx-secondary-nav-tabs',
  templateUrl: './secondary-nav-tabs.component.html',
  styleUrls: ['./secondary-nav-tabs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, CommonModule, IconSvgComponent],
})
export class SecondaryNavTabsComponent {
  tabs: InputSignal<SecondaryNavTab[]> = input<SecondaryNavTab[]>([]);
  changeTab: OutputEmitterRef<string> = output<string>();
}
